/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import HierarchyModal from './Utils/HierarchyModal';
import { UpSquareOutlined } from '@ant-design/icons';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { Form, Select, Button, message, DatePicker, Modal, Checkbox } from 'antd';
import { API_ASSET, MAXIMOASSET, API_DEVICETYPE } from '../../../commons/api';
import {
  getDeviceList,
  getHierarchyFromAPI,
  getListById,
  submit,
  getHierarchyFromAPIForAsset
} from './Utils/FormCalls';

const { Option } = Select;
const { TimePicker } = DatePicker;

const ApiList = {
  getAssetList: `${API_ASSET.GETASSETBYMODULE}`,
  getDeviceTypeListByAsset: `${API_DEVICETYPE.getDeviceTypeListByAsset}`,
  getDeviceListByDeviceType: `${MAXIMOASSET.DeviceList}`,
  getFaultCodesList: `${MAXIMOASSET.FaultCodeList}`,
  Submit: `${MAXIMOASSET.UpdateAFCDetails}`,
  SubmitAsset: `${MAXIMOASSET.UpdateParameterAsset}`
};

const SRHaltTime = (props) => {
  const [formObject, setFormObject] = useState({});
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [treeVisible, setTreeVisible] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [assetChecked, setAssetChecked] = useState(false);
  const [deviceChecked, setDeviceChecked] = useState(true);
  const [typeValue, setTypeValue] = useState('Device');
  const [checkedValue, setCheckedValue] = useState([]);
  const [hierarchy, setHierarchy] = useState([]);
  const [FaultCodesList, setFaultCodesList] = useState([]);
  const [FaultCodesListAsset, setFaultCodesListAsset] = useState([]);
  const [selectedDeviceObject,setSelectedDeviceObject] = useState('');
  const [Asset, setAsset] = useState([]);
  const hRef = useRef(null);

  const record = props.location && props.location.state ? props.location.state.record : {};

  useEffect(() => {
    const fetchData = async () => {
      await getData();
      await getHierarchyData('Device');
      const deviceListData = await getDeviceList();
      setDeviceList(deviceListData);
    };
    fetchData();
  }, []);

  const getData = async () => {
    const timeInterval = record && record.Interval;
    const interval = timeInterval ? moment(timeInterval, 'HH:mm:ss') : null;
    const formValues = {
      ...record,
      Interval: interval,
      ParameterCode: record.AmsParameter
    };
    if (hRef.current) {
      hRef.current.setFieldsValue(formValues);
    }
    setFormObject(formValues);
  };

  const getHierarchyData = async (type) => {
    const path = props.location.pathname.split('/rubus/Maximo/');
    const Module = path[1].split('/') && path[1].split('/')[0];
    const hierarchyData = await getHierarchyFromAPI(Module, type);
    setHierarchy(hierarchyData);
  };

  const getHierarchyDataForAsset = async (type) => {
    const path = props.location.pathname.split('/rubus/Maximo/');
    const Module = path[1].split('/') && path[1].split('/')[0];
    const assetData = await getHierarchyFromAPIForAsset(Module, type);
    setAsset(assetData);
  };

  
    const fieldOnChange = async (value, key, checked, typeValue) => {
      let path = props.location.pathname.split('/rubus/Maximo/');
      let Module = path[1].split('/') && path[1].split('/')[0];
  
      if (value !== undefined) {
        let updatedFormObject = {
          ...formObject,
          [key]: value
        };
  
        if (key === 'Station') {
          let payload = { AssetCode: value };
          let deviceTypeList1 = await getListById(ApiList.getDeviceTypeListByAsset, payload);
          setDeviceTypeList([
            ...(deviceTypeList1 && Array.isArray(deviceTypeList1) && deviceTypeList1.length > 0
              ? [{ AssetCode: 'All', Code: 'All', Description: 'All', AssetName: 'All' }]
              : []),
            ...deviceTypeList1
          ]);
        } else if (key === 'deviceType') {
          let payload = { Module: Module, AssetDeviceType: value };
          let deviceList1 = await getListById(ApiList.getDeviceListByDeviceType, payload);
          setDeviceList([
            ...(deviceList1 && Array.isArray(deviceList1) && deviceList1.length > 0
              ? [{ AssetCode: 'All', DeviceCode: 'All', DeviceName: 'All', Description: 'All' }]
              : []),
            ...deviceList1
          ]);
        } else if (key === 'DeviceCode') {
          let payload;
          if (typeValue === 'Device') {
            payload = { Module: Module, DeviceCode: value, Type: typeValue };
            let FaultCodesList1 = await getListById(ApiList.getFaultCodesList, payload);
            setFaultCodesList([
              ...(FaultCodesList1 && Array.isArray(FaultCodesList1) && FaultCodesList1.length > 0
                ? [{ DeviceCode: 'All', Code: 'All', Description: 'All', DeviceName: 'All' }]
                : []),
              ...FaultCodesList1
            ]);
          } else if (typeValue === 'Asset') {
            payload = { Module: Module, AssetCode: value, Type: typeValue };
            let FaultCodesList2 = await getListById(ApiList.getFaultCodesListAsset, payload, Module);
            setFaultCodesListAsset([
              ...(FaultCodesList2 && Array.isArray(FaultCodesList2) && FaultCodesList2.length > 0
                ? [{ DeviceCode: 'All', DeviceName: 'All', Code: 'All', Description: 'All' }]
                : []),
              ...FaultCodesList2
            ]);
          }
        } else if (key === 'Interval') {
          // No additional API calls for Interval, just update the formObject
        }
  
        setFormObject(updatedFormObject);
        if (hRef.current !== null) {
          hRef.current.setFieldsValue(updatedFormObject);
        }
      }
      setSelectedDevices(checked);
      setDeviceTypeList(deviceTypeList);
    };

    const onFormSubmit = async () => {
      let path = props.location.pathname.split('/rubus/Maximo/');
      let Module = path[1].split('/') && path[1].split('/')[0];
  
      try {
        const values = await hRef.current.validateFields();
        const formattedInterval = values.Interval
          ? moment(values.Interval).format('HH:mm:ss')
          : null;
  
        let payload;
        if (formObject.Type === 'Asset') {
          payload = {
            Interval: formattedInterval,
            AssetCode: typeValue === 'Asset' ? values['AssetCode'] : selectedDeviceObject,
            Module: Module,
            HaltStatus: values['HaltStatus'],
            ParameterCode: values['ParameterCode'],
            Type: values['Type']
          };
          const response = await submit(ApiList.SubmitAsset, payload, typeValue);
          message.success(response.message);
        } else {
          payload = {
            Interval: formattedInterval,
            DeviceCode: typeValue === 'Device' ? values['DeviceCode'] : selectedDeviceObject,
            Module: Module,
            HaltStatus: values['HaltStatus'],
            ParameterCode: values['ParameterCode'],
            Type: values['Type']
          };
          const response = await submit(ApiList.Submit, payload, typeValue);
          message.success(response.message);
        }
      } catch (error) {
        // Handle validation error if needed
        console.error('Validation failed:', error);
      }
    };
  

  const onModalOk = (e) => {
    e.preventDefault();
    fieldOnChange(selectedDevices, 'DeviceCode', checkedValue, typeValue);
    setTreeVisible(false);
  };

  const onModalCancel = () => {
    setTreeVisible(false);
  };

  const hierarchyDropdownChange = (value, data) => {
    setCheckedValue(value);
    setSelectedDeviceObject(data);
  };

  const checkboxOnChange = (e, type) => {
    setTypeValue(type);
    setAssetChecked(type === 'Asset' ? e.target.checked : false);
    setDeviceChecked(type === 'Device' ? e.target.checked : false);
    getHierarchyData(type);
  };
  const checkboxOnChangeAsset = (e, type) => {
    setTypeValue(type);
    setAssetChecked(type === 'Asset' ? e.target.checked : false);
    setDeviceChecked(type === 'Device' ? e.target.checked : false);
    getHierarchyDataForAsset(type);
  };

  return (
    <Form
      name="Equipment Master"
      theme={themeSettings}
      ref={hRef}
      onFinish={onFormSubmit}
      initialValues={formObject || {}}
      layout="horizontal"
      labelCol={{ flex: '200px' }}
      labelAlign="right"
      labelWrap
    >
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Form.Item>
          <Button theme={themeSettings} type="primary" htmlType="submit">
            {'Submit'}
          </Button>
        </Form.Item>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Form.Item
          name={formObject.Type === 'Asset' ? 'AssetCode' : 'DeviceCode'}
          label={'Select Device'}
          rules={[{ required: false, message: 'Please Select Device!' }]}
          style={{ width: '100%', flex: '100%' }}
        >
          <span style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Select
              style={{ width: '75%', opacity: 1, pointerEvents: 'none' }}
              value={selectedDevices.length ? selectedDevices : formObject.DeviceCode || formObject.AssetCode || []}
              mode="multiple"
              placeholder={'Select Device'}
              
            >
              {deviceList && Array.isArray(deviceList) && deviceList.map((device, index) => (
                <Option key={index} value={`${device.DeviceCode}`}>
                  {device.Name}::{device.DeviceCode}
                </Option>
              ))}
            </Select>
            <Button
              style={{ width: '5%' }}
              type="primary"
              onClick={() => setTreeVisible(true)}
              disabled={formObject && formObject.Id ? true : false}
            >
              <UpSquareOutlined />
            </Button>
          </span>
        </Form.Item>
        <Form.Item
          label="Parameter Code"
          name="ParameterCode"
          rules={[{ required: false }]}
          style={{ width: '100%', flex: '100%' }}
        >
          <Select
            placeholder="Please select Fault Code"
            style={{ width: '80%' }}
            mode={'multiple'}
            onChange={(value) => fieldOnChange(value, 'ParameterCode', checkedValue)}
            disabled={formObject && formObject.Id ? true : false}
          >
            {(typeValue === 'Device' ? FaultCodesList : FaultCodesListAsset).map((item, index) => (
              <Option
                key={index}
                value={item.Code !== 'All' ? `${item.DeviceCode}$$$${item.Code}` : 'All'}
              >
                {item.Code !== 'All' ? `${item.Description}@${item.DeviceName}` : 'All'}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Fault Interval"
          name="Interval"
          rules={[{ required: true }]}
          style={{ width: '100%', flex: '100%' }}
        >
          <TimePicker
            format={'mm:ss'}
            style={{ width: '80%' }}
            onChange={(value) => fieldOnChange(value, 'Interval', checkedValue)}
          />
        </Form.Item>
        <Form.Item
          label="Status"
          name="HaltStatus"
          style={{ width: '100%', flex: '100%' }}
          rules={[{ required: true }]}
        >
          <Select placeholder="Please select Status" style={{ width: '80%' }}>
            <Option key={'Enabled'} value={true}>
              {'Enabled'}
            </Option>
            <Option key={'Disabled'} value={false}>
              {'Disabled'}
            </Option>
          </Select>
        </Form.Item>
      </div>
      <Modal
        open={treeVisible}
        width={800}
        closable
        title={'Select Device'}
        okText={'Add'}
        onOk={onModalOk}
        onCancel={onModalCancel}
      >
        <div>
          <Checkbox
            value="Asset"
            checked={assetChecked}
            onChange={(e) => checkboxOnChangeAsset(e, 'Asset')}
          >
            Asset
          </Checkbox>
          <Checkbox
            value="Device"
            checked={deviceChecked}
            onChange={(e) => checkboxOnChange(e, 'Device')}
          >
            Device
          </Checkbox>
        </div>
        <HierarchyModal
          selectedDevice={selectedDevices || []}
          treeData={deviceChecked ? hierarchy : Asset}
          Key="Trends"
          handleDropdownChange={hierarchyDropdownChange}
          checkedArray={checkedValue || []}
        />
      </Modal>
    </Form>
  );
};

export default SRHaltTime;